export const ONLY_DEV = () => {
  switch (process.env.NEXT_PUBLIC_ENV) {
    case 'stg':
    case 'prd':
      return false;
  }
  return true;
};
